// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-byod-device-configuration.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-byod-device-configuration',
  title: 'Enforce technical configuration requirements on BYOD devices',
  description:
    "Personally-owned devices used for service delivery must meet configuration requirements: not be jailbroken or rooted; be running the latest or latest minus one (N-1) approved operating system version; be enrolled in the organisation's MDM or EMM system; and have technical controls enabled including VPN, access restrictions, data separation, security event logging and automatic updates.",
  category: 'technical',
  scfIds: ['SCF-AST-006', 'SCF-OPS-005'],
  cadence: { frequency: '6m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'BYOD device configuration standard is published' },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
